(function () {
  function summaryLine(title, qty) {
    return qty + "x " + title;
  }

  // Accepts: "6 bottles", "5 bottles / 1 glass", "4 bottles / 2 glasses"
  // Also accepts "6 beers" if wording ever changes.
  function parseSlotsFromOption(optionValue) {
    var text = String(optionValue || "");

    var beerMatch = text.match(/(\d+)\s*(?:x\s*)?(?:bottles?|beers?)/i);
    var glassMatch = text.match(/(\d+)\s*(?:x\s*)?(?:glasses?|glass)/i);

    return {
      beerSlots: beerMatch ? Number(beerMatch[1]) : 0,
      glassSlots: glassMatch ? Number(glassMatch[1]) : 0
    };
  }

  function initGiftPack(root) {
    if (root.dataset.apexGiftPackInit === "true") return;
    root.dataset.apexGiftPackInit = "true";

    var cards = Array.prototype.slice.call(
      root.querySelectorAll("[data-apex-gift-pack-card]")
    );

    var addBtn = root.querySelector("[data-apex-gift-pack-add-btn]");
    var addBtnSurface = root.querySelector("[data-apex-gift-pack-add-btn-surface]");
    var errorEl = root.querySelector("[data-apex-gift-pack-error]");
    var progressBeerEl = root.querySelector("[data-apex-gift-pack-progress-beer]");
    var progressGlassEl = root.querySelector("[data-apex-gift-pack-progress-glass]");
    var selectionWrap = root.querySelector("[data-apex-gift-pack-selection]");
    var selectionList = root.querySelector("[data-apex-gift-pack-selection-list]");
    var glassSection = root.querySelector("[data-apex-gift-pack-glass-section]");

    // Find the product section this gift pack lives inside
    var productIsland = root.closest('data-island[src="product"]');
    var productRootId = productIsland ? productIsland.getAttribute("data-product-root") : null;

    // Find the variant picker select inside THIS product section (important)
    var optionSelect = null;
    if (productIsland) {
      optionSelect = productIsland.querySelector("[data-single-option-selector]");
    }

    var initialVariantId = Number(root.getAttribute("data-parent-variant-id") || "0");

    var initialOptionText = "";
    if (optionSelect) {
      initialOptionText = optionSelect.value || "";
    }

    var initialSlots = parseSlotsFromOption(initialOptionText);

    var state = {
      variantId: initialVariantId,
      beerSlots: initialSlots.beerSlots,
      glassSlots: initialSlots.glassSlots,
      beerTotal: 0,
      glassTotal: 0,
      lines: new Map(),
      loading: false
    };

    if (!cards.length || !state.variantId) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.setAttribute("aria-disabled", "true");
      }
      return;
    }

    function showError(message) {
      if (!errorEl) return;
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = "";
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function clearSelections() {
      cards.forEach(function (card) {
        var qtyValue = card.querySelector("[data-apex-gift-pack-qty-value]");
        if (qtyValue) qtyValue.textContent = "0";
      });
      state.lines.clear();
      state.beerTotal = 0;
      state.glassTotal = 0;
    }

    function updateSelectionSummary() {
      if (!selectionWrap || !selectionList) return;
      selectionList.innerHTML = "";

      if (!state.lines.size) {
        selectionWrap.hidden = true;
        return;
      }

      state.lines.forEach(function (line) {
        var li = document.createElement("li");
        li.className = "apex-gift-pack__selection-item";
        li.textContent = summaryLine(line.title, line.quantity);
        selectionList.appendChild(li);
      });

      selectionWrap.hidden = false;
    }

    function updateCardStates() {
      cards.forEach(function (card) {
        var qtyValue = card.querySelector("[data-apex-gift-pack-qty-value]");
        var incBtn = card.querySelector('[data-action="increment"]');
        var decBtn = card.querySelector('[data-action="decrement"]');

        var type = card.getAttribute("data-type") || "beer";
        var qty = Number(qtyValue ? qtyValue.textContent : "0");
        var maxQty = Number(card.getAttribute("data-max-qty") || "0");

        var slots = type === "glass" ? state.glassSlots : state.beerSlots;
        var total = type === "glass" ? state.glassTotal : state.beerTotal;

        var canIncrement = !state.loading && qty < maxQty && total < slots;
        var canDecrement = !state.loading && qty > 0;

        card.classList.toggle("is-selected", qty > 0);

        if (incBtn) {
          incBtn.disabled = !canIncrement;
          incBtn.setAttribute("aria-disabled", canIncrement ? "false" : "true");
        }
        if (decBtn) {
          decBtn.disabled = !canDecrement;
          decBtn.setAttribute("aria-disabled", canDecrement ? "false" : "true");
        }
      });
    }

    function updateProgress() {
      if (progressBeerEl) {
        progressBeerEl.textContent =
          state.beerTotal + " of " + state.beerSlots + " beers selected";
      }

      if (progressGlassEl) {
        var showGlass = state.glassSlots > 0;
        progressGlassEl.hidden = !showGlass;
        progressGlassEl.textContent =
          state.glassTotal + " of " + state.glassSlots + " glasses selected";
      }

      if (glassSection) {
        glassSection.hidden = state.glassSlots < 1;
      }

      if (!addBtn) return;

      var hasAnySlots = state.beerSlots + state.glassSlots > 0;
      var complete =
        state.beerTotal === state.beerSlots &&
        state.glassTotal === state.glassSlots;

      var canSubmit = hasAnySlots && complete && !state.loading;

      addBtn.disabled = !canSubmit;
      addBtn.classList.toggle("disabled", !canSubmit);
      addBtn.setAttribute("aria-disabled", canSubmit ? "false" : "true");

      if (addBtnSurface) {
        addBtnSurface.textContent = state.loading ? "Adding..." : "Add to basket";
      }
    }

    function recalc() {
      state.lines.clear();
      state.beerTotal = 0;
      state.glassTotal = 0;

      cards.forEach(function (card) {
        var qtyValue = card.querySelector("[data-apex-gift-pack-qty-value]");
        var qty = Number(qtyValue ? qtyValue.textContent : "0");
        var variantId = Number(card.getAttribute("data-variant-id") || "0");
        var title = card.getAttribute("data-product-title") || "";
        var type = card.getAttribute("data-type") || "beer";

        if (type === "glass") state.glassTotal += qty;
        else state.beerTotal += qty;

        if (qty > 0 && variantId) {
          state.lines.set(String(variantId), {
            id: variantId,
            title: title,
            quantity: qty,
            type: type
          });
        }
      });

      updateProgress();
      updateSelectionSummary();
      updateCardStates();
    }

    function adjust(card, direction) {
      if (state.loading) return;

      var qtyValue = card.querySelector("[data-apex-gift-pack-qty-value]");
      if (!qtyValue) return;

      var current = Number(qtyValue.textContent || "0");
      var next = current;

      var type = card.getAttribute("data-type") || "beer";
      var maxQty = Number(card.getAttribute("data-max-qty") || "0");

      var slots = type === "glass" ? state.glassSlots : state.beerSlots;
      var total = type === "glass" ? state.glassTotal : state.beerTotal;

      if (direction === "increment") {
        if (current >= maxQty || total >= slots) return;
        next = current + 1;
      }

      if (direction === "decrement") {
        next = Math.max(0, current - 1);
      }

      if (next === current) return;

      qtyValue.textContent = String(next);
      recalc();
    }

    function buildPayload() {
      var summary = [];
      state.lines.forEach(function (line) {
        summary.push(summaryLine(line.title, line.quantity));
      });

      return {
        items: [
          {
            id: state.variantId,
            quantity: 1,
            properties: {
              _apex_gift_pack: "true",
              _apex_gift_pack_contents: summary.join("|")
            }
          }
        ],
        sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
        sections_url: window.location.pathname
      };
    }

    async function submitGiftPack() {
      if (state.loading) return;

      if (state.beerTotal !== state.beerSlots || state.glassTotal !== state.glassSlots) {
        showError("Please complete the gift pack before adding to basket.");
        return;
      }

      showError("");
      state.loading = true;
      updateProgress();
      updateCardStates();

      try {
        var response = await fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify(buildPayload())
        });

        var data = await response.json();
        if (data.status) {
          showError(data.description || "Unable to add gift pack to cart.");
        } else {
          clearSelections();
          recalc();

          document.body.dispatchEvent(
            new CustomEvent("shapes:cart:afteradditem", {
              bubbles: true,
              detail: { response: data, sourceId: "apex-gift-pack" }
            })
          );
        }
      } catch (error) {
        showError("Unable to add gift pack to cart. Please try again.");
        console.error(error);
      } finally {
        state.loading = false;
        updateProgress();
        updateCardStates();
      }
    }

    // ✅ Single place to update slots (used by BOTH event + select fallback)
    function applySlotText(optionText) {
      var slotConfig = parseSlotsFromOption(optionText);

      state.beerSlots = slotConfig.beerSlots;
      state.glassSlots = slotConfig.glassSlots;

      clearSelections();
      showError("");
      recalc();
    }

    // Click handler
    root.addEventListener("click", function (event) {
      var qtyButton = event.target.closest("[data-action]");
      if (qtyButton) {
        var card = qtyButton.closest("[data-apex-gift-pack-card]");
        if (!card) return;
        adjust(card, qtyButton.getAttribute("data-action"));
        return;
      }

      if (addBtn && event.target.closest("[data-apex-gift-pack-add-btn]")) {
        event.preventDefault();
        submitGiftPack();
      }
    });

    // ✅ Primary: theme’s variant change event (use variant.title)
    document.addEventListener("shapes:product:variantchange", function (event) {
      var detail = event.detail || {};
      var variant = detail.variant;

      // If theme provides sectionId/rootId, filter to this product section.
      // If not present, we still update (gift pack should only exist once anyway).
      if (detail.sectionId && productRootId && detail.sectionId !== productRootId) return;
      if (detail.productRoot && productRootId && detail.productRoot !== productRootId) return;

      if (!variant || !variant.id) return;

      state.variantId = Number(variant.id);

      // variant.title is exactly: "6 bottles", "5 bottles / 1 glass" etc
      applySlotText(variant.title || "");
    });

    // ✅ Fallback: if the event never fires, the select ALWAYS changes.
    if (optionSelect) {
      optionSelect.addEventListener("change", function () {
        // let theme update currentVariant first, then apply
        setTimeout(function () {
          applySlotText(optionSelect.value || "");
        }, 0);
      });
    }

    // Initialise correctly on load
    applySlotText(initialOptionText);

    // (applySlotText calls recalc already)
  }

  function boot() {
    document.querySelectorAll("[data-apex-gift-pack]").forEach(initGiftPack);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();